module.exports = __webpack_public_path__ + "static/media/03_Hennessy (ft Lorentz)_eq 05-14.55c5b2ac.mp3";